
import { Home, Users, Bell, Settings, MessageSquare, User, Newspaper, Bot, Building2, MessageSquareText, TrendingUp, GraduationCap } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export interface NavItem {
  icon?: React.ElementType;
  label: string;
  path: string;
  publicAccess?: boolean;
}

interface NavItemProps extends NavItem {
  onClick?: () => void;
  isCollapsed?: boolean;
}

export const NavItem = ({ icon: Icon, label, path, onClick, isCollapsed }: NavItemProps) => {
  const location = useLocation();
  const isActive = location.pathname === path;

  return (
    <Link
      to={path}
      onClick={onClick}
      className={cn(
        "w-full justify-start text-foreground hover:bg-muted hover:text-foreground font-['SF_Pro_Display'] flex items-center space-x-2 p-2 rounded-lg transition-all duration-200",
        isActive && "bg-muted",
        isCollapsed && "justify-center"
      )}
    >
      {Icon && <Icon className="h-5 w-5" />}
      {!isCollapsed && <span>{label}</span>}
    </Link>
  );
};

export const getNavigationItems = (onClick?: () => void): NavItem[] => {
  return [
    {
      icon: Home,
      label: "Home",
      path: "/",
      publicAccess: true,
    },
    {
      icon: Users,
      label: "Community",
      path: "/communities",
      publicAccess: true,
    },
    {
      icon: Building2,
      label: "Startups",
      path: "/communities/startups",
    },
    {
      icon: MessageSquareText,
      label: "Forums",
      path: "/f",
    },
    {
      icon: GraduationCap,
      label: "Lessons",
      path: "/communities/lessons",
    },
    {
      icon: MessageSquare,
      label: "Feed",
      path: "/feed",
    },
    {
      icon: TrendingUp,
      label: "Trending",
      path: "/trending",
    },
    {
      icon: Bot,
      label: "AI",
      path: "/vesu-ai",
    },
    {
      icon: User,
      label: "Profile",
      path: "/profile",
    },
    {
      icon: Settings,
      label: "Settings",
      path: "/settings",
    },
    {
      icon: Newspaper,
      label: "Blog",
      path: "/blog",
      publicAccess: true,
    },
  ];
};
